(() => {
  angular
    .module('complianceFrameworkApp')
    .config(config);

  /* ngInject */
  function config($urlRouterProvider, $stateProvider) {
    // Handle unknown paths
    $urlRouterProvider.otherwise('/');

    $stateProvider
      .state('application', {
        abstract: true,
        templateUrl: '/templates/layouts/application.html',
        data: {
          requireLogin: true
        }
      })

      .state('unauthenticated', {
        abstract: true,
        templateUrl: '/templates/layouts/unauthenticated.html',
        data: {
          requireLogin: false
        }
      })
    ;
  }
})();
